import { BookkeepingTag, BookkeepingTagWithoutVatRates } from '../types/bookkeepingTag'

export const removeVatRatesFromBookkeepingTag = (bookkeepingTag: BookkeepingTag): BookkeepingTagWithoutVatRates => {
  const { vatRates, ...rest } = bookkeepingTag

  return rest
}
